import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { ApiUrlHelper } from '../../common/api-url-helper';
import { CommonService } from '../../services/common/common.service';
import { SharedService } from '../../services/shared-service/shared.service';
import { CommonErrorMessages } from '../../constants/error-messages';
import { ForgotPassLabelConstants } from '../../constants/label-constants';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss'],
})

export class ForgotPasswordComponent implements OnInit {

  forgotPassWordForm!: FormGroup;
  isEmailSend: boolean = false;
  submitted: boolean = false;
  errorMessages: any;
  labelConstants: any;
  isLoading: boolean = false;
  currentYear: number = new Date().getFullYear();;


  constructor(
    private readonly spinner: NgxSpinnerService,
    private readonly api: ApiUrlHelper,
    private readonly toastr: ToastrService,
    private readonly commonService: CommonService,
    private readonly fb: FormBuilder,
    private readonly sharedService: SharedService
  ) { }

  ngOnInit(): void {
    this.sharedService.setData('Forgot Password');
    this.forgotPassWordForm = this.fb.group({
      UserEmail: [
        '',
        [
          Validators.required,
          Validators.email,
          Validators.pattern(
            /^(?=.{1,30}@)[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
          ),
        ],
      ],
    });
    this.errorMessages = CommonErrorMessages;
    this.labelConstants = ForgotPassLabelConstants;
  }

  get EmailFormValidations() {
    return this.forgotPassWordForm.controls;
  }

  submitForgotPassForm() {
    this.submitted = true;
    if (this.forgotPassWordForm.valid) {
      this.setLoadingState(true);
      this.submitted = false;
      this.spinner.show();
      let api = this.api.apiUrl.ForgotPassword.ForgotSendEmail;
      let ForgotPassRequestModel = {
        EmailId: this.forgotPassWordForm.value.UserEmail?.trim(),
      };
      this.commonService.doPost(api, ForgotPassRequestModel).pipe().subscribe({
        next: (response) => {
          if (response.success) {
            this.setLoadingState(false);
            this.forgotPassWordForm.reset();
            this.submitted = false;
            this.spinner.hide();
            this.toastr.success(response.message);
            this.isEmailSend = true;
          } else {
            this.setLoadingState(false);
            this.spinner.hide();
            this.toastr.error(response.message);
          }
        },
        error: (err) => {
          this.setLoadingState(false);
          this.spinner.hide();
        }
      });
    }
  }

  setLoadingState(isLoading: boolean) {
    this.isLoading = isLoading;
    if (isLoading) {
      this.forgotPassWordForm.disable();
    } else {
      this.forgotPassWordForm.enable();
    }
  }
}
